<nb-tabset fullWidth>
    <nb-tab
        *ngFor='let key of schema.properties | keys; let i=index;'
        [tabTitle]="key"
    >
        <sf-form-element [formProperty]='formProperty.getProperty(key)'>
        </sf-form-element>
    </nb-tab>
</nb-tabset>
